<template>
    <div class="hero-v2">
        <NuxtImg 
            format="webp"
            :src="$image(content.imgPath)" 
            :alt="content.title" 
            class="object-contain w-[200px] h-[200px] md:w-[220px] md:h-[220px] self-start md:self-center"
        />
        <div class="content flex flex-col justify-center">
            <h6 v-if="content.subject" class="font-roboto font-bold text-[24px] leading-7 text-neutral-500 mb-2">
                {{ content.subject }}
            </h6>
            <h2 class="font-roboto font-bold md:font-black text-[24px] md:text-[44px] leading-[40px] md:leading-[53px] text-[#212529] mb-2" :class="[titleClass]">
                {{ content.title }}
            </h2>
            <span :class="[textClass]">{{ content.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeroV2',
    props: {
        content: {
            type: Object,
            default: () => ({}),
        },
        imgStyle: {
            type: [Object, String],
            default: () => ({ width: '220px', height: '220px' }),
        },

        titleClass: {
            type: String,
            default: '',
        },
        textClass: {
            type: String,
            default: 'font-manrope font-semibold text-[20px] lg:text-[24px] leading-7 lg:leading-8 tracking-[-0.75px] text-black',
        },
    },

};
</script>

<style lang="scss" scoped>

.hero-v2{
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    align-items: center;

    .content{
        padding: 4px 16px;
        text-align: start;
        .subject{
            font-size: 20px;
            font-weight: 700;
        }
    }

    @media (min-width: 996px) {
        flex-direction: row;
        gap: 80px;
        justify-content: unset;
        align-items: unset;

        .content{
            padding: 24px 0;
            text-align: left;
            .subject{
                font-size: 24px;
            }
        }
    }
}

</style>

